import { render, staticRenderFns } from "./GerarRelatorioClientes.vue?vue&type=template&id=04a059fe&scoped=true&"
import script from "./GerarRelatorioClientes.vue?vue&type=script&lang=js&"
export * from "./GerarRelatorioClientes.vue?vue&type=script&lang=js&"
import style0 from "./GerarRelatorioClientes.vue?vue&type=style&index=0&id=04a059fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a059fe",
  null
  
)

export default component.exports